import { render, staticRenderFns } from "./TopBarUserMenu.vue?vue&type=template&id=3338ceaa&"
import script from "./TopBarUserMenu.vue?vue&type=script&lang=ts&"
export * from "./TopBarUserMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3338ceaa')) {
      api.createRecord('3338ceaa', component.options)
    } else {
      api.reload('3338ceaa', component.options)
    }
    module.hot.accept("./TopBarUserMenu.vue?vue&type=template&id=3338ceaa&", function () {
      api.rerender('3338ceaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/TopBarUserMenu.vue"
export default component.exports